<template>

  <v-card class="ma-3" outlined>
    <v-card-text class="pa-1">
      <v-row no-gutters>
        <v-text-field v-model="c_query" class="ma-1" outlined dense hide-details clearable label="Caută" background-color="white" prepend-inner-icon="mdi-magnify"/>
      </v-row>
    </v-card-text>
  </v-card>

</template>


<script>
  export default {

    props: {
      query: null
    },

    computed: {
      c_query: {
        get() {
          return this.query;
        },
        set(val) {
          this.$emit("update:query", val);
        }
      }
    },
  }
</script>